
import React, { useState } from 'react';
import PageBox from '../../components/PageBox';
import './index.less'
import { Link } from "react-router-dom";
import { CaretRightOutlined } from '@ant-design/icons';
import jiagou from "../../static/images/jiagou.png"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='homeBanner'></div>
        <div className='titleBox'>
          <div className='con'>
            <span>PRODUCT</span>
            <h3>产品服务与应用场景</h3>
          </div>
        </div>
        <div className='hexin'>
          <ul>
            <li>
              <h3>招标采购交易数智化平台、产品应用场景</h3>
              <div className='list'>
                <span>数智采平台</span>
                <span>政府采购</span>
                <span>建设工程</span>
                <span>央企国企</span>
                <span>产权交易</span>
                <span>外资外贷</span>
                <span>深圳政采自行采购</span>
                <span>招标人自定义</span>
                <span></span>
              </div>
              <div><Link to="/syster">查看详情<CaretRightOutlined /></Link></div>
            </li>
            <li>
              <h3>云产品与服务</h3>
              <div className='list'>
                <span>云订阅</span>
                <span>专属云</span>
                <span>本地化部署</span>
                <span>运营运维服务</span>
                <span>咨询服务</span>
                <span>用友云产品</span>
              </div>
              <div><Link to="/cloud">查看详情<CaretRightOutlined /></Link></div>
            </li>
            <li>
              <h3>垂类智能体系统</h3>
              <div className='list'>
                <span style={{width:'40%'}}>招标文件智能生成与审查</span>
                <span>投标文件交叉比对</span>
                <span>市场调研与分析</span>
                <span style={{minWidth:'20%'}}>合同质检</span>
                <span style={{minWidth:'20%'}}>智能评审</span>
                <span style={{minWidth:'20%'}}>智能咨询</span>
                <span style={{minWidth:'20%'}}>模型推理</span>
                <span style={{minWidth:'20%'}}>模型训练</span>
                <span>价格趋势与指数</span>
                <span style={{width:'60%'}}>投标供应商基础信息与关联关系查询（参考）</span>
                
              </div>
              <div><Link to="/aimodel">查看详情<CaretRightOutlined /></Link></div>
            </li>
            <li>
              <h3>增值赋能服务</h3>
              <div className='list'>
                <span>行业知识库</span>
                <span>投标保函</span>
                <span>订单融资</span>
                <span>履约保函</span>
                <span>领域数据治理</span>
                <span>云对象存储</span>
              </div>
              <div><Link to="/addvalue">查看详情<CaretRightOutlined /></Link></div>
            </li>
          </ul>
        </div>
        <div className='jiagou'>
          <div className='titleBox'>
            <div className='con'>
              <span style={{color:'#ddd'}}>SYSTER</span>
              <h3>平台系统架构</h3>
            </div>
          </div>
          <div className='jiagou-con'>
            <img src={jiagou} />
          </div>
        </div>
      </PageBox>
    </>
    
  );
}
